var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoCircle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 18.3333C14.6017 18.3333 18.3327 14.6024 18.3327 9.99999C18.3327 5.39762 14.6017 1.66666 9.99935 1.66666C5.39698 1.66666 1.66602 5.39762 1.66602 9.99999C1.66602 14.6024 5.39698 18.3333 9.99935 18.3333Z",
    fill: "#586572"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.4583C10.3417 11.4583 10.625 11.175 10.625 10.8333V6.66666C10.625 6.32499 10.3417 6.04166 10 6.04166C9.65833 6.04166 9.375 6.32499 9.375 6.66666V10.8333C9.375 11.175 9.65833 11.4583 10 11.4583Z",
    fill: "#FFEEDC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.766 13.0167C10.7243 12.9167 10.666 12.825 10.591 12.7417C10.5077 12.6667 10.416 12.6083 10.316 12.5667C10.116 12.4833 9.88268 12.4833 9.68268 12.5667C9.58268 12.6083 9.49102 12.6667 9.40768 12.7417C9.33268 12.825 9.27435 12.9167 9.23268 13.0167C9.19102 13.1167 9.16602 13.225 9.16602 13.3333C9.16602 13.4417 9.19102 13.55 9.23268 13.65C9.27435 13.7583 9.33268 13.8417 9.40768 13.925C9.49102 14 9.58268 14.0583 9.68268 14.1C9.78268 14.1417 9.89102 14.1667 9.99935 14.1667C10.1077 14.1667 10.216 14.1417 10.316 14.1C10.416 14.0583 10.5077 14 10.591 13.925C10.666 13.8417 10.7243 13.7583 10.766 13.65C10.8077 13.55 10.8327 13.4417 10.8327 13.3333C10.8327 13.225 10.8077 13.1167 10.766 13.0167Z",
    fill: "#FFEEDC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle2);
export default __webpack_public_path__ + "static/media/info-circle2.12d76c4107c840c24e352f91fda4a77b.svg";
export { ForwardRef as ReactComponent };